import { toast } from 'react-hot-toast';

import { createLeadWithOauth } from '@utils/backend-api/oauth';
import { CreateLeadWithOauthParams } from '@utils/backend-api/oauth';

const useOauthCreateUser = () => {
  const createUser = async (values: CreateLeadWithOauthParams) => {
    try {
      const response = await createLeadWithOauth(values);
      window.location.href = response.location;
    } catch (error) {
      toast.error(error.message);
    }
  };

  return { createUser };
};

export default useOauthCreateUser;
